import { RightSideModal, RightSideModalTitle } from 'components';
import * as c from 'models/constants';
import * as React from 'react';
import { IStore } from 'redux/IStore';
import { Dispatch, connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ITranslateProps, InjectedFormProps } from 'models/common';
import { InjectedManualBookingModalProps, InjectedQueryParams, ManualBookingScreen } from '..';
import { translate } from 'react-i18next';
import { IManualBookingFormData } from 'models/shop/manualbooking';
import { Field } from 'redux-form';
import { BookingInputField } from 'components/FormControls';
import { IServiceGroup } from 'models/shop/serviceGroups';
import { IServicesList } from 'models/shop/shopBookingTemplates';
import { IGroupedServices, groupBy, groupServices } from 'containers/Shop/Helpers';
import { getOfficeServiceGroups } from 'redux/modules/shop/serviceGroups';
import { getBookingTemplatesByOffice, getBundleWithChildrenAndResources } from 'redux/modules/shop/bookingtemplates';
import { deleteURLSearchParams, formatCurrency, formatDuration, readMultipleURLSearchParams } from 'helpers/common';
import { IFormAddBookingItemRequest } from 'models/bookappointment';
import { IOfficeMember } from 'models/shop/members';
import { combineDateAndTime } from 'helpers/bookingTemplates';
import { momentWithTimezone } from 'redux/modules/shop/helpers';
import renderIcon from 'helpers/renderIcon';
const classNames = require('classnames');
const moment = require('moment');
require('./style.scss');

interface IOwnProps extends InjectedManualBookingModalProps {}

interface IState {
	servicesSearchCurrent?: string;
	servicesSearch?: string;

	selectedCategoryKey?: string;
	groupedServices?: IGroupedServices;

	servicesCount?: number;
}

export interface ISelectServiceScreenQueryParams extends InjectedQueryParams {
	serviceSelectMode?: 'add' | 'swap';
	prevBookingItemIndex?: string;
}

type IProps = IOwnProps &
	ReturnType<typeof stateToProps> &
	ReturnType<typeof dispatchToProps> &
	ITranslateProps &
	InjectedFormProps;

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SelectServiceScreenComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.onSubmitSearchForm = this.onSubmitSearchForm.bind(this);
		this.loadGroupedServicesIntoState = this.loadGroupedServicesIntoState.bind(this);
		this.normalService = this.normalService.bind(this);
		this.renderServices = this.renderServices.bind(this);

		this.state = {};
	}
	componentDidMount(): void {
		//TODO: Check if exists

		if (
			(!this.props.serviceGroups.serviceGroups?.length && !this.props.serviceGroups.isFetching) ||
			((!this.props.shopBookingTemplates.services?.length || !this.props.shopBookingTemplates.servicesById) &&
				!this.props.shopBookingTemplates.isFetching)
		) {
			this.props.getBookingTemplates(this.props.officeId);
		} else {
			this.loadGroupedServicesIntoState();
		}
	}

	componentWillUnmount(): void {
		this.props.change('serviceSearch', '');
		deleteURLSearchParams(['serviceSelectMode', 'prevBookingItemIndex']);
	}

	loadGroupedServicesIntoState() {
		// Filter out services with no resources on them
		// Filter by search
		const officeBookingTemplates = this.state.servicesSearch
			? this.props.shopBookingTemplates.services
					.filter((ser) => ser?.resources?.length)
					.filter((s) => s.name.toLowerCase().includes(this.state.servicesSearch.toLowerCase()))
			: this.props.shopBookingTemplates.services.filter((s) => s?.resources?.length);

		const groupedServices = groupServices(
			this.props.serviceGroups.serviceGroups,
			officeBookingTemplates || this.props.shopBookingTemplates.services,
			true,
		);

		this.setState({ groupedServices });
		this.setState({ servicesCount: officeBookingTemplates?.length || 0 });

		// For first load select first category key
		if (!this.state?.selectedCategoryKey) {
			this.setState({ selectedCategoryKey: groupedServices.order[0] });
		}

		// Set the first found category key if booking template is not in the same category, if empty sets it back to category of first item
		if (
			this.state?.selectedCategoryKey &&
			officeBookingTemplates?.length &&
			officeBookingTemplates[0].categoryKey.toString() !== this.state.selectedCategoryKey
		) {
			this.setState({ selectedCategoryKey: officeBookingTemplates[0].categoryKey.toString() });
		}
	}

	componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>): void {
		if (
			this.state.servicesSearch !== prevState.servicesSearch ||
			(this.props.serviceGroups.serviceGroups?.length &&
				this.props.shopBookingTemplates.services?.length &&
				((!prevProps.serviceGroups.serviceGroups && this.props.serviceGroups.serviceGroups) ||
					prevProps.serviceGroups.serviceGroups?.length != this.props.serviceGroups.serviceGroups?.length ||
					(!prevProps.shopBookingTemplates.services && this.props.shopBookingTemplates.services) ||
					prevProps.shopBookingTemplates.services?.length != this.props.shopBookingTemplates.services?.length))
		) {
			this.loadGroupedServicesIntoState();
		}
	}

	private onSubmitSearchForm(form?: any) {
		form?.preventDefault();

		this.setState({ servicesSearch: !!this.state.servicesSearchCurrent?.length && this.state.servicesSearchCurrent });
	}

	private normalService(
		selected: boolean,
		variantParentId: string,
		variations: IServicesList[],
		parentService?: IServiceGroup,
	) {
		const { manageShop, t, currentFormValues, timezone, params } = this.props;
		const bookingTemplate = variations[0];
		const baseClassName = 'select-service-screen__services-list__service-group__subservices__subservice-field';

		let name: string;
		if (parentService) {
			name = `${parentService.value} / ${bookingTemplate.name}`;
		} else {
			name = bookingTemplate.name;
		}

		const customBundleData = JSON.parse(bookingTemplate?.customData || '{}');
		const minDuration = variations.reduce((prev, curr) => (curr.duration > prev ? prev : curr.duration), Infinity);
		return (
			<div
				key={`${baseClassName}__${variantParentId}`}
				className={classNames(baseClassName, {
					[`${baseClassName}--selected`]: selected,
				})}
				onClick={() => {
					// Prevent the selected services from being selected again
					if (!selected) {
						const variation =
							variations.find((v) => v.resources.some((r: IOfficeMember) => r.id === params?.resourceId)) ||
							variations.find((v) => v.resources.includes(params?.resourceId)) ||
							variations[0];

						const newItem: Partial<IFormAddBookingItemRequest> = {
							bookingTemplateId: variation.id,
							resourceId:
								(variation.resources.find((res: IOfficeMember) => res?.id === params?.resourceId) as IOfficeMember)
									?.id ||
								(variation.resources.find((resId: string) => resId === params?.resourceId) as string) ||
								(variation.resources[0] as IOfficeMember)?.id ||
								(variation.resources[0] as string),
							duration: variation.duration,
						};
						const prevBookingItems: IFormAddBookingItemRequest[] = [...(currentFormValues.bookingItems || [])];

						if (JSON.parse(variation?.customData)?.isBundle) {
							// fetch bundle children (save in redux form)
							this.props
								.getBundleChildren(variation.id)
								.then((res: IServicesList) => {
									newItem.childrenAddBookingItemRequest = res.childrenBookingTemplates.map((cbt) => {
										return {
											bookingTemplateId: cbt.id,
											resourceId:
												(cbt.resources.find((res: IOfficeMember) => res?.id === params?.resourceId) as IOfficeMember)
													?.id ||
												(cbt.resources.find((resId: string) => resId === params?.resourceId) as string) ||
												(cbt.resources[0] as IOfficeMember)?.id ||
												(cbt.resources[0] as string),
											schedule: null,
										};
									});

									if (prevBookingItems?.length) {
										// If items exist, add booking item at the end of the last item
										if (params?.serviceSelectMode === 'add') {
											const lastItem = prevBookingItems.reduce(
												(prev, curr) => (moment(prev.schedule).isBefore(moment(curr.schedule)) ? curr : prev),
												prevBookingItems[0],
											);
											newItem.schedule = moment(lastItem.schedule)
												.add(lastItem.duration, 'seconds')
												.toDate()
												.toISOString();
										} else if (params?.serviceSelectMode === 'swap') {
											const bookingItemToSwap: IFormAddBookingItemRequest =
												this.props.currentFormValues.bookingItems[params.prevBookingItemIndex];
											newItem.schedule = bookingItemToSwap.schedule;
											this.props.mode === 'edit' && bookingItemToSwap?.productId
												? (newItem.productId = bookingItemToSwap.productId)
												: undefined;
										}
									} else {
										//TODO: check if dateOfTheAppointment always includes time
										newItem.schedule = combineDateAndTime(
											momentWithTimezone(timezone, currentFormValues.dateOfTheAppointment),
											momentWithTimezone(timezone, currentFormValues.startTimeOfTheAppointment),
										)
											.toDate()
											.toISOString();
									}

									// For setting schedule of child items
									let previousChildItemSchedule: IFormAddBookingItemRequest = null;

									newItem.childrenAddBookingItemRequest = res.childrenBookingTemplates.map((cbt, idx) => {
										const childBookingItem = {
											bookingTemplateId: cbt.id,
											resourceId:
												(cbt.resources.find((res: IOfficeMember) => res?.id === params?.resourceId) as IOfficeMember)
													?.id ||
												(cbt.resources.find((resId: string) => resId === params?.resourceId) as string) ||
												(cbt.resources[0] as IOfficeMember)?.id ||
												(cbt.resources[0] as string),
											schedule: null,
											duration: cbt.duration,
										};
										if (idx === 0) {
											childBookingItem.schedule = newItem.schedule;
										} else {
											childBookingItem.schedule = moment(previousChildItemSchedule.schedule)
												.add(previousChildItemSchedule.duration, 'seconds')
												.toDate()
												.toISOString();
										}
										previousChildItemSchedule = childBookingItem;
										return childBookingItem;
									});

									if (params?.serviceSelectMode === 'add') {
										prevBookingItems.push(newItem as IFormAddBookingItemRequest);
										this.props.change('bookingItems', prevBookingItems);
										this.props.setScreen(ManualBookingScreen.Main);
									} else if (params?.serviceSelectMode === 'swap') {
										this.props.change(`bookingItems[${params.prevBookingItemIndex}]`, newItem);
										prevBookingItems?.length
											? this.props.setScreen(ManualBookingScreen.EditService, {
													bookingItemIndex: params.prevBookingItemIndex,
											  })
											: this.props.setScreen(ManualBookingScreen.Main);
									}
								})
								.catch((err) => {
									console.error(err);
								});
						} else {
							if (prevBookingItems?.length) {
								// If items exist, add booking item at the end of the last item
								if (params?.serviceSelectMode === 'add') {
									const lastItem = prevBookingItems.reduce(
										(prev, curr) => (moment(prev.schedule).isBefore(moment(curr.schedule)) ? curr : prev),
										prevBookingItems[0],
									);

									newItem.schedule = moment(lastItem.schedule).add(lastItem.duration, 'seconds').toDate().toISOString();
								} else if (params?.serviceSelectMode === 'swap') {
									const bookingItemToSwap: IFormAddBookingItemRequest =
										this.props.currentFormValues.bookingItems[params.prevBookingItemIndex];
									newItem.schedule = bookingItemToSwap.schedule;
									this.props.mode === 'edit' && bookingItemToSwap?.productId
										? (newItem.productId = bookingItemToSwap.productId)
										: undefined;
								}
							} else {
								//TODO: check if dateOfTheAppointment always includes time
								newItem.schedule = combineDateAndTime(
									momentWithTimezone(timezone, currentFormValues.dateOfTheAppointment),
									momentWithTimezone(timezone, currentFormValues.startTimeOfTheAppointment),
								)
									.toDate()
									.toISOString();
							}

							if (params?.serviceSelectMode === 'add') {
								prevBookingItems.push(newItem as IFormAddBookingItemRequest);
								this.props.change('bookingItems', prevBookingItems);
								this.props.setScreen(ManualBookingScreen.Main);
							} else if (params?.serviceSelectMode === 'swap') {
								this.props.change(`bookingItems[${params.prevBookingItemIndex}]`, newItem);
								prevBookingItems?.length
									? this.props.setScreen(ManualBookingScreen.EditService, {
											bookingItemIndex: params.prevBookingItemIndex,
									  })
									: this.props.setScreen(ManualBookingScreen.Main);
							}
						}
					}
				}}
			>
				<h4 className={`${baseClassName}__name`}>{name}</h4>
				{customBundleData?.isBundle && (
					<div className={`${baseClassName}__subtitle`}>{customBundleData.bundleChildrenNames?.join(', ')}</div>
				)}
				<div className={`${baseClassName}__footer`}>
					<span className={`${baseClassName}__footer__duration`}>
						{variations.length > 1
							? `${t('BSPortal_Common_From').toLowerCase()} ${formatDuration(minDuration)}`
							: formatDuration(minDuration)}
					</span>
					<div className={`${baseClassName}__footer__price`}>
						<span className={`${baseClassName}__footer__price__old`}>
							{manageShop.shop?.currencyKey &&
								bookingTemplate?.price &&
								bookingTemplate?.price != bookingTemplate.originalPrice &&
								formatCurrency(manageShop.shop?.currencyKey, bookingTemplate?.originalPrice)}
						</span>
						<span className={`${baseClassName}__footer__price__new`}>
							{manageShop.shop?.currencyKey &&
								bookingTemplate?.price &&
								formatCurrency(manageShop.shop?.currencyKey, bookingTemplate?.price)}
						</span>
					</div>
				</div>
			</div>
		);
	}

	private renderServices() {
		const { currentFormValues, shopBookingTemplates } = this.props;
		const { groupedServices, selectedCategoryKey } = this.state;
		if (!groupedServices || !selectedCategoryKey) {
			return <></>;
		}
		const selectedVpIds = groupBy(
			currentFormValues.bookingItems
				?.filter((b) => !b?.deleted)
				.map((bi) => shopBookingTemplates?.servicesById?.[bi.bookingTemplateId]) || [],
			'variantParentId',
		);
		const categoryGrouped = groupedServices.children[selectedCategoryKey];
		return categoryGrouped?.order.map((serviceGroupId) => {
			const groupedServiceGroup = categoryGrouped.children[serviceGroupId];

			if (
				!this.state.servicesSearchCurrent ||
				(this.state.servicesSearchCurrent &&
					groupedServiceGroup?.children &&
					Object.values(groupedServiceGroup.children)?.some((sg) => sg?.order !== undefined))
			) {
				return (
					<React.Fragment key={`select-service-screen_React.Fragment_${serviceGroupId}`}>
						<h3 className="select-service-screen__services-list__service-group__name">
							{groupedServiceGroup?.serviceGroup?.value}
						</h3>
						<div className="select-service-screen__services-list__service-group__subservices">
							{groupedServiceGroup?.order?.map((serviceId) => {
								const groupedService = groupedServiceGroup.children[serviceId];
								// Variant parent ids
								const subserviceIds = groupedService?.children ? Object.keys(groupedService.children) : [];
								if (subserviceIds?.length > 1) {
									return subserviceIds.map((variantParentId) =>
										this.normalService(
											variantParentId in selectedVpIds,
											variantParentId,
											groupedService.children[variantParentId],
											groupedService.serviceGroup,
										),
									);
								} else if (subserviceIds?.length === 1) {
									return this.normalService(
										subserviceIds[0] in selectedVpIds,
										subserviceIds[0],
										groupedService.children[subserviceIds[0]],
									);
								}
							})}
						</div>
					</React.Fragment>
				);
			}
		});
	}

	public render() {
		const { t, startCloseModal, closeModal } = this.props;
		const { groupedServices } = this.state;

		// Filter empty category keys
		const serviceCategoryTabs =
			groupedServices?.order.filter((categoryKey) => groupedServices.children[categoryKey].order.length) || [];

		return (
			<RightSideModal
				modalClass="select-service-screen"
				size="small"
				header={
					<>
						<RightSideModalTitle
							title={t('ManualBookingModal_SelectService_AddService')}
							backButtonClick={() => this.props.setScreen(ManualBookingScreen.Main)}
							closeModalClick={
								(this.props.mode === 'add' && !this.props.dirty) ||
								(this.props?.mode === 'edit' && !this.props?.currentFormValues?.isEditModeEnabled)
									? closeModal
									: startCloseModal
							}
						/>
						<form className="select-service-screen__header__search-container" onSubmit={this.onSubmitSearchForm}>
							<Field
								name="serviceSearch"
								component={BookingInputField}
								placeholder={t('ManualBookingModal_SelectService_SearchServices')}
								className="select-service-screen__header__search-container__search-field"
								customIconName="search_gray"
								onChangeAction={(e) => {
									this.setState({ servicesSearchCurrent: e.target.value });
								}}
								functionToTriggerOnSearch={() => this.onSubmitSearchForm()}
								iconInside
							/>
						</form>
						<div className="manual-booking-modal__tabs">
							{serviceCategoryTabs.map((categoryKey) => {
								return (
									<div
										className={`manual-booking-modal__tab ${
											this.state.selectedCategoryKey === categoryKey ? 'active' : ''
										}`}
										onClick={() => this.setState({ selectedCategoryKey: categoryKey })}
										key={`service_select_screen_category_${categoryKey}`}
									>
										{t(`DV_ServiceCategories_${categoryKey}`)}
									</div>
								);
							})}
						</div>
					</>
				}
			>
				{groupedServices && this.renderServices()}
				{this.state?.servicesCount === 0 ? (
					<div className="select-service-screen__no-results">
						{renderIcon('search_not_found', undefined, undefined, 'select-service-screen__no-results__icon')}
						<h3 className="select-service-screen__no-results__title">
							{t('ManualBookingModal_SelectService_NoResults_Title')}
						</h3>
					</div>
				) : null}
			</RightSideModal>
		);
	}
}

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	getBookingTemplates: (officeId) => {
		dispatch(getOfficeServiceGroups(officeId, true));
		dispatch(getBookingTemplatesByOffice(officeId, true, undefined, undefined, false, true));
	},
	getBundleChildren: (bookingTemplateId: string) => dispatch(getBundleWithChildrenAndResources(bookingTemplateId)),
});

const stateToProps = (state: IStore) => {
	let currentFormValues: IManualBookingFormData = null;
	const params: ISelectServiceScreenQueryParams = readMultipleURLSearchParams([
		'serviceSelectMode',
		'prevBookingItemIndex',
		'resourceId',
	]);

	if (state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN] && state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values) {
		currentFormValues = state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values;
	}

	return {
		currentFormValues,
		serviceGroups: state.serviceGroups,
		shopBookingTemplates: state.shopBookingTemplates,
		manageShop: state.manageShop,
		params,
	};
};

export const SelectServiceScreen = connect(
	stateToProps,
	dispatchToProps,
)(
	reduxForm({
		form: c.FORM_NAME_MANUAL_BOOKING_PLAN,
		enableReinitialize: false,
		destroyOnUnmount: false,
	})(SelectServiceScreenComponent),
);
